/*
 * @Description: 版本路由
 * @Author: gao shuai
 * @Date: 2020-06-21 15:07:01
 * @LastEditTime: 2020-08-20 14:25:07
 * @LastEditors: gao shuai
 */

export const url = process.env.NODE_ENV !== 'production' ? 'http://121.204.253.94:5003' : 'https://pa.231pay.com'; // 接口的ip__zx固定
